<nav class="header">
  <div class="title" data-test-id="title">
    Today is <strong class="today" data-test-id="today">{{ today }}</strong>
  </div>
</nav>
